export default "f7bc5d696ecfccd7.svg"